import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    formatPhoneNum: null,
    formatDateTime: null,
    dialog: {
      opened: false
    }
  },
  mutations: {
    FORMAT_PHONE_NUMBER: (state, phone) => {
      let array = phone.split('');
      const result = array.map((el, index) => {
        if (index <= 6 && index >= 4) {
          return '*';
        } else {
          return el;
        }
      });
      state.formatPhoneNum = result.join('');
      sessionStorage.setItem('formatPhoneNumber', state.formatPhoneNum);
    },
    FORMAT_DATE_TIME: (state, dateTime) => {
      let Y = dateTime.substring(0, 4) + '/';
      let M = dateTime.substring(4, 6) + '/';
      let D = dateTime.substring(6, 8) + ' ';
      let h = dateTime.substring(8, 10) + ':';
      let m = dateTime.substring(10, 12) + ':';
      let s = dateTime.substring(12);

      state.formatDateTime = Y + M + D + h + m + s;
      sessionStorage.setItem('formatDateTime', state.formatDateTime);
    },
    TOGGLE_DIALOG: (state, status) => {
      state.dialog.opened = status;
      if (state.dialog.opened) {
        document.body.style.overflow = 'hidden';
      } else {
        document.body.style.overflow = 'scroll';
      }
    }
  },
  actions: {
    formatPhoneNumber({ commit }, phone) {
      commit('FORMAT_PHONE_NUMBER', phone);
    },
    formatDateTime({ commit }, dateTime) {
      commit('FORMAT_DATE_TIME', dateTime);
    },
    toggleDialog({ commit }, status) {
      commit('TOGGLE_DIALOG', status);
    }
  },
  getters: {
    phoneNumber: state =>
      sessionStorage.getItem('formatPhoneNumber') || state.formatPhoneNum,
    expirationDate: state =>
      sessionStorage.getItem('formatDateTime') || state.formatDateTime,
    dialog: state => state.dialog
  },
  modules: {}
});
